export class AppError extends Error {
    code;
    constructor(code) {
        super(code);
        this.code = code;
        if ('captureStackTrace' in Error)
            Error.captureStackTrace(this, AppError);
    }
}
